import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRight } from "@vfit/ui/icons";
import { AnchorLabel, Container } from "./anchorBox.style";
var AnchorBox = function(param) {
    var isDarkMode = param.isDarkMode, anchorLabel = param.anchorLabel, anchorLink = param.anchorLink;
    return /*#__PURE__*/ _jsxs(Container, {
        darkMode: isDarkMode,
        onClick: function() {
            return console.log(anchorLink);
        },
        children: [
            /*#__PURE__*/ _jsx(AnchorLabel, {
                children: anchorLabel
            }),
            /*#__PURE__*/ _jsx(ChevronRight, {})
        ]
    });
};
export default AnchorBox;
